export default __webpack_public_path__ + "static/media/project-img.a1c25fca.png";